<template>
    <div>
      <h4 
        v-if="product_name.length < maxLength"
      >
        {{ product_name }}
      </h4>
      <h4 
        v-else 
        :title="product_name"
      >
        {{ product_name.substr(0, maxLength) + "..." }}
      </h4>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      product_name: {
        type: String,
        required: true
      },
      maxLength: {
        type: Number,
        default: 47
      }
    }
  };
  </script>